import React from 'react'
import styles from './styles.module.css';
import Colors from '../../../../colors';

function OutlineButton({ label, color, onClick, style, disabled }) {
  const buttonStyle = {
    cursor: disabled ? 'not-allowed' : 'pointer',
    color: disabled ? Colors.lightGray2 : color,
    border: `1px solid ${disabled ? Colors.lightGray2: color}`,
  };

  return (
    <button
      className={styles.button}
      style={{ ...buttonStyle, ...style }}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  )
}

export default OutlineButton;
